import { takeLatest, call, put } from 'redux-saga/effects';
import api from '../../api/index';
import {
  GET_WHATS_NEW, SET_WHATS_NEW, WHATS_NEW_REQUEST_FAILED, SENDING_WHATS_NEW_REQUEST,
} from '../../types/Types';

/**
 * Call the api and dispatch data to the reducer
 * @param { Object } action Contained object data to be send to API call
 */
export function* getWhatsNew(action) {
  const { data } = action;
  try {
    yield put({
      type: SENDING_WHATS_NEW_REQUEST,
      wData: '',
      isWSending: true,
      isWSuccess: false,
      wError: false,
    });
    const response = yield call(api.whatsNew, data);
    if (response) {
      yield put({
        type: SET_WHATS_NEW,
        wData: response.toString(),
        isWSending: false,
        wError: false,
        isWSuccess: true,
      });
    } else {
      yield put({
        type: WHATS_NEW_REQUEST_FAILED,
        wData: null,
        isWSending: false,
        wError: true,
        isWSuccess: false,
        wMsg: response.errorMsg,
      });
    }
  } catch (e) {
    yield put({
      type: WHATS_NEW_REQUEST_FAILED,
      wMsg: e.message,
      isWSending: false,
      wError: true,
      isWSuccess: false,
      wData: null,
    });
  }
}

/**
 * map the dispatched action to the above function
 */
export default function* watchGetWhatsNew() {
  yield takeLatest(GET_WHATS_NEW, getWhatsNew);
}
